import { useEffect, useState } from 'react';
import {
  collection, query, where, orderBy, onSnapshot, getDocs,
} from 'firebase/firestore';
import { db } from '../firebase/config';

export function useDisputedOrders() {
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(
      collection(db, 'orders'),
      where('status', '==', 'disputed'),
      orderBy('createdAt', 'desc')
    );
    return onSnapshot(q, snap => {
      setOrders(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
  }, []);

  return { orders, loading };
}

export function useAllOrders() {
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'orders'), orderBy('createdAt', 'desc'));
    return onSnapshot(q, snap => {
      setOrders(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
  }, []);

  return { orders, loading };
}

export function useAllUsers() {
  const [users, setUsers]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'users'), orderBy('createdAt', 'desc'));
    return onSnapshot(q, snap => {
      setUsers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
  }, []);

  return { users, loading };
}

export function useAllInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'invoices'), orderBy('createdAt', 'desc'));
    return onSnapshot(q, snap => {
      setInvoices(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(i => !i.kind));
      setLoading(false);
    });
  }, []);

  return { invoices, loading };
}

// Hent leveringsdokument for ett oppdrag (én gangs henting)
export async function fetchOrderDelivery(orderId) {
  const q = query(collection(db, 'deliveries'), where('orderId', '==', orderId));
  const snap = await getDocs(q);
  return snap.empty ? null : { id: snap.docs[0].id, ...snap.docs[0].data() };
}

export function useAllOrganizations() {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading]             = useState(true);
  const [error, setError]                 = useState(null);

  useEffect(() => onSnapshot(
    collection(db, 'organizations'),
    snap => {
      setOrganizations(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    },
    err => {
      console.error('useAllOrganizations:', err);
      setError(err);
      setLoading(false);
    },
  ), []);

  return { organizations, loading, error };
}
